export default __webpack_public_path__ + "static/media/NTORQ 125 RACE EDITION_5.d8c8575a.webp";